import classNames from "classnames";
import { useMapMeasure } from "hooks/ol/useMapMeasure";
import { useEffect, useState } from "react";
import styles from "./MeasureControl.module.scss";

export default function MeasureControl() {
  const { addMeasureInteraction, initMeasureInteraction, measureOn, measureOff } = useMapMeasure();
  const [showGuide, setShowGuide] = useState(false);
  const [isMeasureMode, setIsMeasureMode] = useState(false);
  let drawType: 'Polygon' | 'LineString' = 'Polygon';

  useEffect(() => {
    if (isMeasureMode) {
      setShowGuide(true);
      window.addEventListener('keydown', (event: KeyboardEvent) => { handleKeyEvent(event); });
      measureOn();
      addMeasureInteraction('Polygon');
      return;
    }
    window.removeEventListener('keydown', (event: KeyboardEvent) => { handleKeyEvent(event); })
    measureOff();
  }, [isMeasureMode]);

  const handleMeasureClick = () => {
    setIsMeasureMode(!isMeasureMode);
  }

  const handleKeyEvent = (event: KeyboardEvent) => {
    if (!isMeasureMode) return;
    if (event.code === 'Escape') {
      measureOff();
      measureOn();
      addMeasureInteraction(drawType);
    } else if (event.code === 'KeyA') {
      drawType = 'Polygon';
    } else if (event.code === 'KeyD') {
      drawType = 'LineString';
    }
    initMeasureInteraction(drawType);
  };

  return (
    <>
      <div className={classNames(styles["measure__container"], { [styles["on"]]: isMeasureMode })} onClick={handleMeasureClick}>
        <div className={styles["icon"]}></div>
        <span>Measure</span>
      </div>
      {
        showGuide &&
        <div className={styles["measure-guide__container"]}>
          <div className={styles["measure-header"]}>
            <span>Draw guide</span>
            <div className={styles["close"]} onClick={() => { setShowGuide(false) }}></div>
          </div>
          <div className={styles["measure-body"]}>
            <div className={styles["measure-row"]}>
              <span>End drawing</span>
              <div className={styles["measure-btn"]}>Double click</div>
            </div>
            <div className={styles["measure-row"]}>
              <span>Clear</span>
              <div className={styles["measure-btn"]}>ESC</div>
            </div>
            <div className={styles["measure-row"]}>
              <span>Distance mode</span>
              <div className={styles["measure-btn"]}>D</div>
            </div>
            <div className={styles["measure-row"]}>
              <span>Area mode</span>
              <div className={styles["measure-btn"]}>A</div>
            </div>
          </div>
        </div>
      }
    </>
  )
}